import { useMutation } from '@tanstack/vue-query';
import { dscvrIcApi } from '@/shared/api';

export const useClaimOnboardingRewardMutation = () => {
  return useMutation({
    mutationKey: ['claim-onboarding-reward-mutation'],
    mutationFn: dscvrIcApi.onboarding.claimOnboardingReward,
  });
};
